export const GET_PATIENTS_ADMISSIONS_LIST =
  'patientAdmissions/getPatientAdmissions'
